import { Button } from '@material-ui/core';
import React, { useEffect, useState } from 'react'
import "./ChatInput.css";
import db from "./firebase";
import firebase from "firebase";
import { useStateValue } from "./StateProvider"
function ChatInput({channelName, channelId}) {
    
    const [input, setInput] = useState('');
    const [{ user }] = useStateValue();
    const sendMessage = (event) => {
        event.preventDefault();

        
        if (channelId) {
            db.collection("Rooms").doc(channelId).collection("messages").add({
                message: input,
                timestamp: firebase.firestore.FieldValue.serverTimestamp(),
                user: user.displayName,
                userImage: user.photoURL,
            })
        }
        else{
            console.log("NOOOOOOOOOOOOOOOOOOOOOOO");
        }
    };
    return (
        <div className='chatInput'>
            <form>

                <input placeholder={`Message #${channelName}`} value={input} onChange={e => setInput(e.target.value)}></input>
                <Button type="submit" onClick={sendMessage}>SEND</Button>
            </form>
        </div>
    )
}

export default ChatInput
